import { render, staticRenderFns } from "./FavoriteIcon.vue?vue&type=template&id=fe0898d4&scoped=true&"
import script from "./FavoriteIcon.vue?vue&type=script&lang=ts&"
export * from "./FavoriteIcon.vue?vue&type=script&lang=ts&"
import style0 from "./FavoriteIcon.vue?vue&type=style&index=0&id=fe0898d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe0898d4",
  null
  
)

export default component.exports